$(function () {
    $('.js-toggle-mobile-menu').click(function () {
        $('.mobile-menu_outer').fadeIn(animateSpeed, function () {
            $(this).toggleClass('visible');
            $('body').toggleClass('fixed');
        })
    })

    $('.js-close-mobile-menu').click(function () {
        closeMobileNavWithFade();
    })

    $(window).resize(function () {
        if ($('.mobile-menu_outer.visible').length > 0 && $(window).outerWidth() > 767) {
            closeMobileNav();
        }
    })

    $('.js-toggler-btn').click(function () {
        $(this).toggleClass('toggled');
        $(this).siblings('.js-toggler-content').slideToggle(200, function () {
            $(this).toggleClass('toggled');
        })
    })
});

function closeMobileNav() {
    $('.mobile-menu_outer').removeClass('visible');
    $('.mobile-menu_outer').removeAttr('style');
    $('body').removeClass('fixed');
}

function closeMobileNavWithFade() {
    $('.mobile-menu_outer').fadeOut(animateSpeed, function () {
        $(this).removeClass('visible');
        $('body').removeClass('fixed');
    })
}